export default __webpack_public_path__ + "static/media/logo.c8e502c1.svg";